import { routeList } from '@/router/helpers/routes'
/* Views */
import ThirdLevelMenu from '@/views/ThirdLevelMenu'
import SubscribeTravel from '@/views/bankassurance/subscribe/Travel'
import SubscribeAuto from '@/views/bankassurance/subscribe/Auto'
import SubscribeHealth from '@/views/bankassurance/subscribe/Health'
import Policies from '@/views/bankassurance/Policies'

export default [{
	path: routeList.BANKASSURANCE_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
},
/* ***********************************************
*                     SUBSCRIBE                  *
*********************************************** */
{
	path: routeList.BANKASSURANCE_SUBSCRIBE_PATH,
	name: routeList.BANKASSURANCE_SUBSCRIBE_NAME,
	props: true,
	component: ThirdLevelMenu
}, {
	path: routeList.BANKASSURANCE_SUBSCRIBE_TRAVEL_PATH,
	name: routeList.BANKASSURANCE_SUBSCRIBE_TRAVEL_NAME,
	component: SubscribeTravel
}, {
	path: routeList.BANKASSURANCE_SUBSCRIBE_AUTO_PATH,
	name: routeList.BANKASSURANCE_SUBSCRIBE_AUTO_NAME,
	component: SubscribeAuto
}, {
	path: routeList.BANKASSURANCE_SUBSCRIBE_HEALTH_PATH,
	name: routeList.BANKASSURANCE_SUBSCRIBE_HEALTH_NAME,
	component: SubscribeHealth
},
/* ******************* ************************ */
{
	path: routeList.BANKASSURANCE_POLICIES_PATH,
	name: routeList.BANKASSURANCE_POLICIES_NAME,
	component: Policies
}]
